import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { ConfirmActionModal } from "src/components/Modal";
import { useToast } from "src/components/Toasts/ToastContainer";
import { useCreateAlertMutation } from "src/graphql/anti-fraud/queries/alerts/mutations/CreateAlertMutation";
import { getCaseByIdQuery } from "src/graphql/anti-fraud/queries/cases/GetCaseByIdQuery";
import { useT } from "src/internationalization";
import { Case } from "src/types/case";

export type ConfirmCreateAlertModalProps = {
  case: Case;
  onClose: () => void;
};

export const ConfirmCreateAlertModal: FC<ConfirmCreateAlertModalProps> = ({
  case: caseData,
  onClose,
}) => {
  const t = useT();
  const navigate = useNavigate();
  const { showErrorToast } = useToast();

  const { performMutation: createAlert, loading: creatingAlert } = useCreateAlertMutation({
    onCompleted: (data) => {
      if (!data.createAlert.id) {
        console.error("Expected created alert be defined, but got undefined");
        return;
      }

      navigate(`/alert/${data.createAlert.id}`);
      onClose();
    },
    onError: (error) => {
      showErrorToast(error.message || t("component.toast.container.title") || "An error occurred");
    },
    refetchQueries: [{ query: getCaseByIdQuery, variables: { id: caseData.id } }],
  });

  const caseHeader = `${caseData?.configurableType.name} ${caseData?.request}`;

  return (
    <ConfirmActionModal
      title={t("case.actions.createAlert")}
      subtitle={caseHeader}
      onConfirm={() => {
        createAlert({ caseId: caseData.id });
      }}
      onClose={onClose}
      size="sm"
      loading={creatingAlert}
      confirmButtonText={t("general.actions.create")}
    >
      {t("case.actions.createAlert.modal.confirmation")}
    </ConfirmActionModal>
  );
};
